import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgClockClockwise = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M20 7.566c-2.105-3.708-6.594-5.512-10.774-4.07-4.69 1.624-7.185 6.746-5.562 11.436 1.614 4.7 6.735 7.196 11.435 5.572a8.96 8.96 0 0 0 5.733-6.093"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M20.242 4.271v3.3H16.96M14.992 14.57l-3.174-1.898V8.574"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgClockClockwise);
export default ForwardRef;
